import queryString from 'query-string';

export class OurPartnersCountryService {
  constructor(
    private loader: HTMLElement | null
  ) {}

  getCountries(id: number | null): Promise<any> {
    this.loader?.classList.add('active');
    const queryParams: Record<string, number | string | null> = {};
    queryParams.categoryId = id ?? null;
    return fetch(`/api/country?${queryString.stringify(queryParams)}`, {
      method: 'GET',
      headers: {
        'Authorization': 'true'
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        this.loader?.classList.remove('active');
        return data;
      })
      .catch(error => {
        this.loader?.classList.remove('active');
      });
  }
}
